// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Sticky from 'react-stickynode';

const WarrantyStickyNode = ({children, ...props}) =>
    <Sticky
        {...props}
    >
        {children}
    </Sticky>;

WarrantyStickyNode.displayName = 'WarrantyStickyNode';
WarrantyStickyNode.propTypes = {
    children: PropTypes.node.isRequired
};

export default WarrantyStickyNode;



// WEBPACK FOOTER //
// ./src/shared/components/warranty-sticky-node/index.js